<template>
  <div class="flex flex-grow flex-col text-color-candidate">
    <top-sub-b
      ><span class="text-chplus-xl">{{
        $t("views.government.responsibilities.executive.title")
      }}</span></top-sub-b
    >
    <content-scroll-container class="h-full flex-grow">
      <content-scroll-inner class="h-full lg:px-12" :flow-text="true">
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_explanation_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_explanation_text_1"
            )
          }}
        </p>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_explanation_text_2"
            )
          }}
        </p>
        <hr />
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_eda_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_eda_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_edi_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_edi_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_efd_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_efd_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_uvek_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_uvek_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_wbf_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_wbf_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_vbs_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_vbs_text_1"
            )
          }}
        </p>
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_department_ejpd_title"
            )
          }}
        </div>
        <p>
          {{
            $t(
              "views.government.responsibilities.executive.section_department_ejpd_text_1"
            )
          }}
        </p>
        <hr />
        <div class="font-bold">
          {{
            $t(
              "views.government.responsibilities.executive.section_more_info_title"
            )
          }}
        </div>
        <a
          :href="
            $t(
              'views.government.responsibilities.executive.link_website_easyvote'
            )
          "
          target="_blank"
        >
          <button
            type="button"
            class="p-3 mt-1 mb-8 rounded-lg text-white bg-gradient-blue"
          >
            www.easyvote.ch
          </button></a
        >
        <br />
        <a
          :href="
            $t(
              'views.government.responsibilities.executive.link_website_admin_departments'
            )
          "
          target="_blank"
        >
          <button
            type="button"
            class="p-3 mt-1 mb-8 rounded-lg text-white bg-gradient-blue"
          >
            www.admin.ch
          </button></a
        >
      </content-scroll-inner>
    </content-scroll-container>
  </div>
</template>

<script>
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import TopSubB from "@/components/layouts/TopSubB";

export default {
  name: "Federal",
  components: {
    TopSubB,
    ContentScrollInner,
    ContentScrollContainer
  }
};
</script>
